import React, {useState} from 'react';

import {Button, InputNumber, ModalPopup} from '@kit';

import {useCharacter} from '../../../character-context';
import {healedHitPoints, resourceKey} from '../../../model/procedures';
import {StatePatch, useFeatureAction} from '../use-feature-action';
import type {ProcedureModalProps} from './procedure-modal-props';

import css from '../../sheet.module.css';

const CURE_POISON_COST = 5;

/** Возложение рук: сколько потратить из запаса и на кого */
export const HealingPoolModal: React.FC<ProcedureModalProps<'healingPool'>> = ({action, procedure, onClose}) => {
	const {character} = useCharacter();
	const {record} = useFeatureAction(action);
	const key = resourceKey(procedure.resource);
	const pool = character.limitedUse(key);
	const remaining = pool ? pool.max - pool.spent : 0;
	const [amount, setAmount] = useState(Math.min(remaining, 5));
	const value = Math.max(0, Math.min(remaining, amount || 0));

	const spendPool = (count: number, details: string, patch?: StatePatch) => {
		record(details, (current) => ({
			spentUses: {...current.spentUses, [key]: (current.spentUses[key] || 0) + count},
			...patch?.(current),
		}));
		onClose();
	};

	return (
		<ModalPopup open onClose={onClose} header={action.title} maxWidth={480}>
			<p>
				В запасе <b>{remaining}</b> из {pool?.max ?? 0}.
			</p>
			<div className={css.formRow}>
				<span>Потратить</span>
				<InputNumber min={0} max={remaining} value={value} onChange={(next) => setAmount(next || 0)} />
			</div>
			<div className={css.modalButtons}>
				<Button
					disabled={remaining < CURE_POISON_COST}
					onClick={() => spendPool(CURE_POISON_COST, `снято Отравление: −${CURE_POISON_COST} из запаса`)}
				>
					Снять Отравление ({CURE_POISON_COST})
				</Button>
				<Button disabled={!value} onClick={() => spendPool(value, `лечение другого существа: ${value} ПЗ`)}>
					Вылечить другого
				</Button>
				<Button
					appearance="primary"
					disabled={!value}
					onClick={() =>
						spendPool(value, `лечение себя: ${value} ПЗ`, (current) => ({
							hitPoints: healedHitPoints(current.hitPoints, value),
						}))
					}
				>
					Вылечить себя
				</Button>
			</div>
		</ModalPopup>
	);
};
